<template>
  <div>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon3">Поиск: </span>
      </div>
      <input type="text" class="form-control" v-model="search"/>
    </div>

    <table class="table"
           v-for="(item, itemKey) in items"
           :key="itemKey">
      <thead>
      <tr>
        <th>{{ item.category.name }}</th>
        <th class="text-center font-weight-normal" style="width:100px;">
          Ед.
        </th>
        <th class="text-center font-weight-normal" style="width:100px;">
          Норма
        </th>
        <th class="text-center font-weight-normal" style="width:100px;">
          Стандарт
        </th>
        <th class="text-center font-weight-normal" style="width:100px;">
          Отклонение
        </th>
      </tr>
      </thead>

      <tbody>
      <tr
        v-for="(test, testKey) in item.tests"
        :key="testKey">
        <td>
          <a href="#" @click="$emit('select-test', test.id)">
            {{ test.name }}
          </a>
        </td>
        <td class="text-center">
          {{ test.measure }}
        </td>
        <td class="text-center text-success font-weight-bold">
          {{ test.reference.normal }}
        </td>
        <td class="text-center font-weight-bold">
          {{ test.reference.standard }}
        </td>
        <td class="text-center text-warning font-weight-bold">
          {{ test.reference.deviation }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'TestList',

  props: ['tests', 'categories'],

  data() {
    return {
      search: '',
    };
  },

  computed: {
    items() {
      const grouped = {};

      for (const category of this.categories) {
        grouped[category.id] = {category, tests: []};
      }

      for (const test of this.tests) {
        if (typeof grouped[test.categoryId] === 'undefined') {
          continue;
        }

        grouped[test.categoryId].tests.push(test);
      }

      const items = Object.values(grouped);

      items.sort((a, b) => {
        return a.sort > b.sort ? 1 : (a.sort < b.sort ? -1 : 0);
      });

      for (const item of items) {
        item.tests.sort((a, b) => {
          return a.sort > b.sort ? 1 : (a.sort < b.sort ? -1 : 0);
        });
      }

      return items.filter(item => {
        item.tests = item.tests.filter(test => {
          return test.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1;
        });

        return item.tests.length > 0;
      });
    }
  },
};
</script>
